import { useEffect, useState } from 'react'
import type { Me } from '@/lib/api-types'

/** The account picture (the Google photo when there is one), else the first letter of the name or email. */
export function Avatar({ user, className = 'size-8' }: { user: Me | null | undefined; className?: string }) {
  const src = user?.avatarUrl ?? null
  const [broken, setBroken] = useState(false)
  useEffect(() => {
    setBroken(false)
  }, [src])
  const label = user?.name ?? user?.email ?? user?.telegramUsername ?? ''
  const initial = label.trim().charAt(0).toUpperCase() || '·'
  if (src && !broken) {
    return (
      <img
        src={src}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
        className={`${className} shrink-0 rounded-full bg-surface-2 object-cover`}
      />
    )
  }
  return (
    <span aria-hidden className={`${className} flex shrink-0 items-center justify-center rounded-full bg-accent-soft text-sm font-semibold text-accent`}>
      {initial}
    </span>
  )
}
